Ext.define('Admin.view.machine.Template', {
    extend: 'Admin.view.template.Grid',
    xtype: 'adminmachinetemplate',
    initComponent: function(){
        const me = this;
        const comboEditor = Ext.create({
            xtype: 'combobox',
            displayField: 'name',
            valueField: 'id',
            store: {type: 'adminstore', url: Routes.option_templates_path(), autoLoad: true},
            forceSelection: true
        })
        const comboRenderer = function(cmb){
            return function(value){
                const store = cmb.getStore();
                var idx = store.find(cmb.valueField, value);
                var rec = store.getAt(idx);
                return (rec === null ? '' : rec.get(cmb.displayField) );
            }
        }
        Ext.apply(me,{
            customTBarItems: [{
                position: 0,
                text: 'New Template Schedule',
                handler: function(){
                    const store = this.up().up().up().down('#machine-template-grid').getStore()
                    store.add({template_id: null});
                }
            }],
            columns: [
                {
                    dataIndex: 'template_id',
                    text: 'Template',
                    editor: comboEditor,
                    renderer: comboRenderer(comboEditor),
                    sortable: false,
                    width: '30%'
                },
                {
                    text: 'Valid From',
                    dataIndex: 'valid_from',
                    editor: { 
                        xtype: 'datetimefield', 
                        format: 'd/m/Y H:i' ,
                        submitFormat: 'C'
                    }, 
                    xtype: 'datecolumn', 
                    format:'d/m/Y H:i',
                    sortable: false,
                    menuDisabled: true,
                    width: '30%'
                },
                {
                    text: 'Valid Until',
                    dataIndex: 'valid_to',
                    editor: { 
                        xtype: 'datetimefield', 
                        format: 'd/m/Y H:i',
                        submitFormat: 'C'
                    }, 
                    xtype: 'datecolumn', 
                    format:'d/m/Y H:i',
                    sortable: false,
                    menuDisabled: true,
                    width: '30%'
                },
                {
                    xtype: 'actioncolumn',
                    width: 30,
                    align: 'center',
                    items: [
                        {
                            iconCls: 'x-fa fa-trash x-btn-col-icon-danger',
                            tooltip: 'Remove',
                            text: 'Remove',
                            handler: function(grid, rowIndex, colIndex, item, e, record, row){
                                if( typeof record.get('id') == 'number' ){
                                    Ext.Ajax.request({
                                        method: 'delete',
                                        params:{
                                            authenticity_token: authenticityToken()
                                        },
                                        url: Routes.delete_template_machine_path(record.get('id')),
                                        callback: function(opts, success, err){
                                            if(success){
                                                grid.getStore().remove(record)
                                            }
                                        }
                                    })
                                }else{
                                    grid.getStore().remove(record)
                                }
                            }
                        }
                    ]
                }
            ]
        })
        me.callParent(arguments)
    }
})